import { render, staticRenderFns } from "./TermReport.vue?vue&type=template&id=2838e4ec&scoped=true"
import script from "./TermReport.vue?vue&type=script&lang=js"
export * from "./TermReport.vue?vue&type=script&lang=js"
import style0 from "./TermReport.vue?vue&type=style&index=0&id=2838e4ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2838e4ec",
  null
  
)

export default component.exports